<template>
<div class="all">

  <div ref="crosswisePrint" id="crosswisePrint" class="crosswisePrint"
    style="border:1px solid #ccc;padding:10px;display:inline-block;">
    <div style="text-align:center;font-size:18px;font-weight: bold;">{{hotleInfo.name}}</div>
    <div style="text-align:center;font-size:10px">餐饮交班报表</div>
    <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />
    <div style="text-align: left;font-size:10px;">
      <div style="font-size:10px;">营业日期：{{listQuery.startTime}}至{{listQuery.endTime}}</div>
      <div style="font-size:10px;">打印人：{{employee.name}}</div>
      <div style="font-size:10px;" v-if="! listQuery.shiftCode">班次：
        <!--{{listQuery.shiftCode|shiftCodeFilter}}-->{{queryShiftValue == 1 ? '早班' : queryShiftValue == 2 ? '中班' :queryShiftValue == 3 ? '晚班':queryShiftValue == 4 ? '夜班':'所有' }}
      </div>
      <div style="font-size:10px;" v-if="listQuery.shiftCode">班次：{{listQuery.shiftCode|shiftCodeFilter}}</div>
      <div style="font-size:10px;width:200pxword-wrap:break-word;word-break:break-all;overflow: hidden; "
        v-if="outletsListArrs.length">营业点：<span> {{outletsListArrs.toString()}}</span>

      </div>
      <div style="font-size:10px;width:200pxword-wrap:break-word;word-break:break-all;overflow: hidden; "
        v-if="options.length">工号：<span> {{options.toString()}}</span>

      </div>
      <!-- <div style="font-size:10px;width:200pxword-wrap:break-word;word-break:break-all;overflow: hidden; " v-if="options.length">营业点：<span v-for="(v,i) in options" :key='i'>{{v}} <span v-if=" i != options.length-1 ">,</span> </span>

      </div> -->

    </div>
    <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />
    <div style="text-align: left;font-weight: bold;font-size:12px">销售</div>
    <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />
    <div style="display:flex;font-size:10px;justify-content: space-between;" v-for="item in reportDateTotal"
      :key='item.code'>
      <div v-if="item.total_price" style="padding:4px 0px;">{{item.chinese_desc}}</div>
      <div v-if="item.total_price" style="padding:4px 0px;">{{item.total_price?item.total_price.toFixed(2):'0.00'}}
      </div>
    </div>
    <div style="padding:10px 0px;display:flex;font-size:12px;justify-content: space-between;font-weight: bold;">
      <div>合计</div>
      <div>{{reportDateTotalSum?reportDateTotalSum.toFixed(2):'0.00'}}</div>
    </div>
    <div style="text-align: left;font-weight: bold;font-size:12px">收款</div>
    <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />
    <div style="display:flex;font-size:10px;justify-content: space-between;" v-for="item in payTypeTotal"
      :key='item.productCode+item.productName'>
      <div v-if="item.total_price && item.productCode != 'S' " style="padding:4px 0px;">{{item.productName}}</div>
      <div v-if="item.total_price  && item.productCode != 'S' " style="padding:4px 0px;">
        {{item.total_price?item.total_price.toFixed(2):'0.00'}}</div>
    </div>
    <div style="padding:10px 0px;display:flex;font-size:12px;justify-content: space-between;font-weight: bold;">
      <div>合计</div>
      <div>{{payTypeTotalSum?payTypeTotalSum.toFixed(2):'0.00'}}</div>
    </div>
    <hr style="border:none;border-top:1px dashed #999;margin:6px 0px;" />
    <div style="display:flex;font-size:10px;justify-content: space-between;" v-for="item in payTypeTotal"
      :key='item.productCode'>
      <div v-if="item.total_price && item.productCode == 'S' " style="padding:4px 0px;">{{item.productName}}</div>
      <div v-if="item.total_price  && item.productCode == 'S' " style="padding:4px 0px;">
        {{item.total_price?item.total_price.toFixed(2):'0.00'}}</div>
    </div>
    <hr style="border:none;border-top:1px dashed #999;margin:6px 0px;" />
    <div style="text-align: center;font-size:10px;">打印时间：{{currentTime}}</div>
    <div style="text-align: center;font-size:10px;height:50px">  </div>
       
    <hr style="border:none;border-top:1px dashed #999;margin:6px 0px;" />
       
          <span>&nbsp;</span>
  </div>
</div>

</template>
<script>
  // import {
  //   payTypeTotal
  // } from '@/api/reportcenter/ReportTableDefinition'

  import DateUtils from '@/utils/DateUtils';
  // import getLodop from '@/utils/LodopFuncs.js'
  import getLodop from '../../utils/Lodopfuncs'

  export default {
    data() {
      return {
        currentTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd hh:mm"), //当前的时间
        hotleInfo: JSON.parse(localStorage.getItem('hotel')),
        employee: JSON.parse(localStorage.getItem('user')),
        // user: this.$store.state.user.user,
        listQuery: {
          shiftCode: '',
          userId: '',
          outletId: [],
          startTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd"),
          endTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd ")
        },
        // 营业点接口
        outletsListArrs: [],
        options: [],
        //翻译营业点数组
        listoutId: [],
        reportDateTotal: [],
        payTypeTotal: [],
        reportDateTotalSum: 0,
        payTypeTotalSum: 0,
        queryShiftValue: '',
      }
    },
    created() {
      this.getInit()
      this.$bus.$on('todoQuery', this.getData)
      this.$bus.$on('todoPrintCatering', this.todoPrint)
      this.$bus.$on('outletsListArr', (val) => {
        console.log('outletsListArrs', val);
        this.outletsListArrs = []
        val.map(v => {
          this.listQuery.outletId.map(n => {
            if (n == v.id) {
              this.outletsListArrs.push(v.description)
            }
          })
        })
        // console.log( 123124,this.outletsListArrs);

      })
      this.$bus.$on('options', (val) => {
        // console.log('outletsListArrs', val);
        this.options = []
        val.map(v => {
          this.listQuery.userId.forEach(n => {
            if (n == v.user_id) {

              this.options.push(v.name)
            }
          })
        })
        // console.log( 123124,this.options);
      })

    },
    beforeDestroy() {
      this.$bus.$off('todoQuery', this.getData);
      this.$bus.$off('todoPrintCatering', this.todoPrint)
      this.$bus.$off('outletsListArr')

    },
    methods: {
      getData(val) {
        this.listQuery = Object.assign({}, val)
        this.getInit()
      },
      getInit() {

        let methods = "get"
        let url = this.api.payTypeTotal
        let data = this.listQuery
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          if (res.data.status == 0) {
            this.reportDateTotalSum = 0
            this.payTypeTotalSum = 0
            this.reportDateTotal = res.data.data && res.data.data.reportDateTotal.length > 0 ? res.data.data
              .reportDateTotal : []
            this.payTypeTotal = res.data.data && res.data.data.payTypeTotal.length > 0 ? res.data.data
              .payTypeTotal : []

            this.reportDateTotal.map(v => {
              this.reportDateTotalSum += v.total_price ? v.total_price : 0
            })

            this.payTypeTotal.map(v => {
              if (v.productCode != 'S') {

                this.payTypeTotalSum += v.total_price ? v.total_price : 0
              }
            })

          }

          console.log(this.payTypeTotal);


        })
      },
      todoPrint(type) {
        const LODOP = getLodop()
        // 获取大小和宽度
        let width = 2
        if (LODOP) {
          var strFormHtml =
            "<body>" +
            document.getElementById("crosswisePrint").innerHTML +
            "</body>"; //获取打印内容
          LODOP.PRINT_INIT(""); //初始化
          // LODOP.SET_PRINT_PAGESIZE(3, '100mm', '230mm');
          LODOP.SET_PRINT_PAGESIZE(3, '80mm', '297mm');
          // LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4');
          LODOP.ADD_PRINT_HTM("2%", width + '%', (100 - width * 2) + '%', "83%", strFormHtml); //设置打印内容
          LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 600, ""); //设置预览窗口模式和大小
          if (type === "preview") {
            LODOP.PREVIEW();
          } else {
            LODOP.PRINT();
          }
        }
      },
    },
    mounted() {
      this.$bus.$on('renderQueryShiftValue', val => {
        this.queryShiftValue = val;
      });
    }
  }
</script>
<style scoped>
.all{
  display: flex;
  justify-content: center;
}
  .crosswisePrint {
    width: 300px;
    margin: 20px auto;
    /* margin-top: 20px; */
  }
</style>